import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getLegalityCheck = createAsyncThunk('/legality_check/content', async (nopage) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/companySoFileCheckLegal?page=${nopage}`, {})
        return response.data;
    } catch (err) {
        if (err.response && err.response.status === 401) {
            window.location.href = '/login';
        }
    }
})


export const legalCheckSlice = createSlice({
    name: 'legality_check',
    initialState: {
        isLoading: false,
        legality_check: []
    },

    extraReducers: (builder) => {
        builder
            .addCase(getLegalityCheck.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getLegalityCheck.fulfilled, (state, action) => {
                state.legality_check = action.payload.data;                  
                state.isLoading = false;
            })
            .addCase(getLegalityCheck.rejected, (state) => {
                state.isLoading = false;
            });
    }   
})

export default legalCheckSlice.reducer